export default __webpack_public_path__ + "static/web20220927-d785b9050dc52401ac28efe41194dbaf.png";